import {
  InclusionFilter,
  InclusionMethod,
} from "../../../../legacy/types/companyFilter";

export const getIncludedFilterValues = (
  filter: InclusionFilter[]
): InclusionFilter[] =>
  filter.filter(
    (item) => item.inclusionMethod !== InclusionMethod.NONE_PRESENT
  );

export const getExcludedFilterValue = (
  filter: InclusionFilter[]
): InclusionFilter | undefined => {
  return filter.find(
    (item: InclusionFilter) =>
      item.inclusionMethod === InclusionMethod.NONE_PRESENT
  );
};

export const flatInclusionFilterIds = (filters: InclusionFilter[]): string[] =>
  filters.flatMap((filter) => filter.ids?.map(String) || []);

const createLabelPart = (
  ids: string[] | number[],
  nameMap: Record<string | number, string>,
  suffix: string
): string | null => {
  if (ids.length === 0) return null;
  if (ids.length === 1) {
    const [id] = ids;
    const name = nameMap[id] || id;
    return `${name} ${suffix}`;
  }
  return `${ids.length} ${suffix}`;
};

export const generateInclusionLabel = (
  includeValueIds: string[] | number[],
  excludeValueIds: string[] | number[],
  nameMap: Record<string, string>
): string => {
  const parts: string[] = [];

  const includeLabel = createLabelPart(
    includeValueIds || [],
    nameMap,
    "included"
  );
  if (includeLabel) parts.push(includeLabel);

  const excludeLabel = createLabelPart(
    excludeValueIds || [],
    nameMap,
    "excluded"
  );
  if (excludeLabel) parts.push(excludeLabel);

  return parts.join(", ");
};
